module.exports = __webpack_public_path__ + "img/user-silhouette.64d71069.png";